import React from 'react';
import { Link } from 'react-router-dom';
import { merchantProfile, sampleTransaction } from '../../data/gtbankUatData';
import Div from '../Div';
import { UatInfoRow, UatNote, UatPageShell } from './UatDocumentationPage';

export default function CheckoutConfirmPage() {
  return (
    <UatPageShell
      title="Checkout Confirmation"
      breadcrumb="Checkout Confirm"
      heading="Review Payment Details Before Redirect"
      subtitle="Total amount shown clearly before payment"
    >
      <p className="cs-m0" style={{ opacity: 0.82, lineHeight: 1.8 }}>
        Merchant: {merchantProfile.name}
      </p>
      <Div style={{ marginTop: 24 }}>
        <UatInfoRow label="Customer Name" value={sampleTransaction.customerName} />
        <UatInfoRow label="Service Description" value={sampleTransaction.service} />
        <UatInfoRow label="Reference Number" value={sampleTransaction.referenceNumber} accent />
        <UatInfoRow label="Amount" value={sampleTransaction.amount} />
        <UatInfoRow label="Currency" value={sampleTransaction.currency} />
        <UatInfoRow
          label="Total Amount"
          value={`${sampleTransaction.currency} ${sampleTransaction.amount}`}
          accent
        />
      </Div>
      <UatNote>
        <strong>Please save your transaction reference number.</strong> Use reference number{' '}
        <strong>{sampleTransaction.referenceNumber}</strong> if you need support regarding your
        transaction.
      </UatNote>
      <Div style={{ marginTop: 28, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
        <Link to="/uat/mpgs-payment-pending" className="cs-btn cs-style1" style={{ display: 'inline-flex' }}>
          <span>Proceed to Payment</span>
        </Link>
      </Div>
    </UatPageShell>
  );
}
